<ng-container *ngIf="question">
  <div class="no-comments" *ngIf="countNonEmpty(question.answer.comments) === 0">No comments left</div>
  <dl *ngIf="countNonEmpty(question.answer.comments) > 0">
    <ng-container *ngFor="let comment of question.answer.comments; index as cindex">
      <ng-container *ngIf="comment?.trim()">
        <dt>Q: {{ question.questionNumber }}{{ letter(cindex) }}. {{ question.answer.questions[cindex] }}<br></dt>
        <dd>A: {{ comment }}<br></dd>
      </ng-container>
    </ng-container>
  </dl>
</ng-container>
